/**
 * Subjects a visitor can pick in the Book Appointment Modal, shared so the
 * value the widget submits and the value the backend DTO accepts cannot drift
 * (SH-410).
 *
 * The members are the tokens sent to the SH API Gateway. Unlike
 * {@link ../enums/salutation.Salutation} there is no `subjectToGateway()`
 * mapper — the gateway takes the token as-is — and the German labels shown in
 * the dropdown stay in the widgets' `next-intl` messages (`form.subjectMathe`
 * and siblings), so a copy change never touches this file.
 */
export enum Subject {
  Mathe = 'mathe',
  Deutsch = 'deutsch',
  Englisch = 'englisch',
  Andere = 'andere',
}

const SUBJECT_VALUES: ReadonlySet<string> = new Set(Object.values(Subject));

/** Type guard: is `value` one of the known {@link Subject} values? */
export function isSubject(value: string): value is Subject {
  return SUBJECT_VALUES.has(value);
}
